import { createGrid, themeQuartz } from 'ag-grid-community'
import { makeColumnDefs } from './make-column-defs.js'
import { makeRows } from './make-rows.js'

export function showTableCurrencies (params) {
  console.log('showTableCurrencies')

  const { currencyResponse, browserAppAccount } = params

  const rows = makeRows(currencyResponse)
  console.log('rows', rows)

  const columnDefs = makeColumnDefs(browserAppAccount, currencyResponse)
  console.log('columnDefs', columnDefs)

  const gridOptions = {
    rowData: rows,
    columnDefs,
    defaultColDef: {
      filter: true,
      floatingFilter: true
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    getRowId: (cellParams) => cellParams.data.id,
    onCellClicked: function (cellParams) {
      console.log('onCellClicked', cellParams)
    },
    theme: themeQuartz
  }

  const containerId = 'currencyGrid'
  const gridContainerElement = document.getElementById(containerId)
  console.log('gridContainerElement', gridContainerElement)
  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('grid created', gridApi)
}
